<template>
  <FightReport
      v-if="mode === 'fight'"
      :fight="fight"
      :trainer="trainer"
      :position="position"
      :is-trainer-fight="isTrainerFight ? position.trainerFight : null"
  />
</template>

<script>
import FightReport from '@/components/journey/positions/fight/FightReport';

// Stred bojoveho gridu - dispatch podle modu na existujici FightReport. Obstacle mod stred
// vubec nepouziva (viz BattleLayout.vue chooseMode) - BattleScreen.vue ho pro nej nevykresli.
export default {
  name: "BattleCenter",
  components: {FightReport},
  props: {
    mode: {type: String, required: true}, // 'fight'
    fight: {type: Object, default: null},
    trainer: {type: Object, default: null},
    position: {type: Object, default: null},
    isTrainerFight: {type: Boolean, default: false},
  },
}
</script>
